import { OptionItem } from "@transfr-inc/dashboard-components/forms";

export class SimulationOptionItem extends OptionItem {
  constructor(simulation) {
    const { index, displayName } = simulation;
    super({ id: index, text: displayName, data: simulation });
  }
}
